import { useFetcher } from '@remix-run/react'
import posthog from 'posthog-js'
import { useCallback } from 'react'
import { type ResumePlotSubscriptionActionData } from '#app/routes/resources+/plot.resume-subscripton'

export const useResumePlotSubscription = (
	plotId: string,
	subscriptionId?: string | null,
) => {
	const fetcher = useFetcher<ResumePlotSubscriptionActionData>()

	const resumePlotSubscription = useCallback(async () => {
		if (!subscriptionId || !plotId) return

		const formData = new FormData()
		formData.append('plotId', JSON.stringify(plotId))
		formData.append('subscriptionId', JSON.stringify(subscriptionId))
		fetcher.submit(formData, {
			method: 'POST',
			action: '/resources/plot/resume-subscripton',
		})
		posthog.capture('plot_sub_resumed', { plotId })
	}, [plotId, subscriptionId, fetcher])

	// TODO (low) optimistic update and error handling

	return resumePlotSubscription
}
